<div class="menu-panel-parent">
  <div class="menu-panel-body">
    <div class="global-panel-results menu-panel-results">
        <div class="menu-panel-results-arrow menu-panel-results-arrow-up menu-panel-results-arrow-visibility-collapse"></div>
        <div class="menu-panel-results-list"></div>
        <div class="menu-panel-results-arrow menu-panel-results-arrow-down"></div>
    </div>
  </div>
</div>